<script lang="ts" setup>
import type { DetailsCarItemDetails } from '@autobid/ui/types/components/CarDetails'
import { usePrepareDetailsCarData } from '@autobid/ui/composables/car/usePrepareDetailsCarData'
import { computed } from 'vue'

interface Props {
  details: DetailsCarItemDetails
}

const props = defineProps<Props>()
const { foundDefects } = usePrepareDetailsCarData(
  computed(() => props.details),
)
</script>

<template>
  <tr v-if="foundDefects.display">
    <td>
      <table class="w-full border-collapse">
        <thead>
          <SectionsDetailsPdfElementsHeading as="th">
            {{ foundDefects.title }}
          </SectionsDetailsPdfElementsHeading>
        </thead>
        <tbody>
          <SectionsDetailsElementsTable :table="details.foundDefects" />
        </tbody>
      </table>
    </td>
  </tr>
</template>
